var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.8751C6.75 4.66799 6.58211 4.5001 6.375 4.5001H3.375C3.16789 4.5001 3 4.66799 3 4.8751C3 5.08221 3.16789 5.2501 3.375 5.2501H6.375C6.58211 5.2501 6.75 5.08221 6.75 4.8751Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.3751C6.25 6.16799 6.08211 6.0001 5.875 6.0001H3.375C3.16789 6.0001 3 6.16799 3 6.3751C3 6.58221 3.16789 6.7501 3.375 6.7501H5.875C6.08211 6.7501 6.25 6.58221 6.25 6.3751Z",
    fill: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.5001C6.58211 7.5001 6.75 7.66799 6.75 7.8751C6.75 8.08221 6.58211 8.2501 6.375 8.2501H3.375C3.16789 8.2501 3 8.08221 3 7.8751C3 7.66799 3.16789 7.5001 3.375 7.5001H6.375Z",
    fill: "#272727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.8751H9.5C10.2594 10.8751 10.875 10.2595 10.875 9.5001V6.7501C10.875 6.543 10.7071 6.3751 10.5 6.3751H8.875V2.4717C8.875 1.76 8.07055 1.34601 7.49142 1.75968L7.40389 1.8222C7.01365 2.10094 6.48504 2.10001 6.09296 1.81995C5.44103 1.35429 4.55897 1.35429 3.90704 1.81995C3.51496 2.10001 2.98635 2.10094 2.59611 1.8222L2.50858 1.75968C1.92945 1.34601 1.125 1.76 1.125 2.4717V9.0001C1.125 10.0356 1.96447 10.8751 3 10.8751ZM4.34296 2.43025C4.73412 2.15085 5.26588 2.15085 5.65704 2.43025C6.30805 2.89526 7.18697 2.89882 7.83982 2.4325L7.92735 2.36998C8.01008 2.31089 8.125 2.37003 8.125 2.4717V9.5001C8.125 9.72516 8.17907 9.93759 8.27493 10.1251H3C2.37868 10.1251 1.875 9.62142 1.875 9.0001V2.4717C1.875 2.37003 1.98992 2.31089 2.07265 2.36998L2.16018 2.4325C2.81303 2.89882 3.69195 2.89526 4.34296 2.43025ZM8.875 9.5001V7.1251H10.125V9.5001C10.125 9.84528 9.84518 10.1251 9.5 10.1251C9.15482 10.1251 8.875 9.84528 8.875 9.5001Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAlt);
export default __webpack_public_path__ + "static/media/Invoice-alt.922f7f874c2f6e28ebce7bd075d9abd1.svg";
export { ForwardRef as ReactComponent };